(function(){
  'use strict';

  angular
    .module('app')
    .filter('wrapLastWord', wrapLastWordFilter);

    function wrapLastWordFilter($sce) {
    return function(input, tag = "b") {
      if(input){
        let text = input.trim().split(" ");
        let last = text.pop();
        input = (text.length > 0 ? `${text.join(" ")} <${tag}>${last}</${tag}>` : first);
      }
      return $sce.trustAsHtml(input);
    }
  }

})();
